import { Controller } from "@hotwired/stimulus"

const DEFAULTS = {
  openai:       "gpt-5",
  anthropic:    "claude-sonnet-4-6",
  xai:          "grok-4-fast-reasoning",
  ollama_cloud: "deepseek-v3.2"
}

// On the new-LLM-connection form: when the user picks a provider key,
// reveal the model dropdown, filter it to that provider's models, and
// snap the value to the provider's default. The model field stays hidden
// until a provider is chosen so the form has a clear progressive flow.
export default class extends Controller {
  static targets = ["model", "modelField"]

  connect() {
    const form = this.element.closest("form")
    this.modelSelect = form?.querySelector('[data-llm-key-picker-target="model"]')
    this.modelField  = form?.querySelector('[data-llm-key-picker-target="modelField"]')
    this._refresh()
  }

  update() {
    this._refresh()
  }

  _refresh() {
    const provider = this._selectedProvider()
    if (!provider) {
      this._hideModel()
      return
    }
    this._showModel()
    this._filterByProvider(provider)
  }

  _selectedProvider() {
    const opt = this.element.options[this.element.selectedIndex]
    return opt?.dataset.provider
  }

  _showModel() {
    if (!this.modelField) return
    this.modelField.classList.remove("hidden")
    if (this.modelSelect) this.modelSelect.disabled = false
  }

  _hideModel() {
    if (!this.modelField) return
    this.modelField.classList.add("hidden")
    // Disable so the field's value isn't submitted while hidden.
    if (this.modelSelect) this.modelSelect.disabled = true
  }

  _filterByProvider(provider) {
    if (!this.modelSelect) return
    const options = Array.from(this.modelSelect.options)
    let firstVisible = null
    for (const opt of options) {
      const matches = opt.dataset.provider === provider
      opt.hidden = !matches
      opt.disabled = !matches
      if (matches && !firstVisible) firstVisible = opt
    }
    const preferred = DEFAULTS[provider]
    const preferredOpt = options.find(o => o.dataset.provider === provider && o.value === preferred)
    if (preferredOpt) {
      this.modelSelect.value = preferred
    } else if (firstVisible) {
      this.modelSelect.value = firstVisible.value
    }
  }
}
